import { Outlet } from "react-router-dom";
import ProductProvider from "src/context/ProductProvider";

const ProductLayout = () => {
  return (
    // This is a very basic version of the layout with time, we can update it and add more if necessary.
    <ProductProvider>
      <Outlet />
    </ProductProvider>
  );
};

export default ProductLayout;
